import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson, authHeader } from '../shared.js';
import { orderHistoryResponseSpec } from './specs.js';

const list = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, request) {
        return validateResponse(orderHistoryResponseSpec, (yield fetch(`${apiUrl}/customer/${request.customerId}/history?offset=${request.offset}&limit=${request.limit}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return function list(apiUrl, accessToken, request) {
        return _ref.apply(this, arguments);
    };
}();

export { list };
//# sourceMappingURL=list.js.map
